// This file contains several utility functions.

import React from "react";
import { Col, Form, Row, Table } from "react-bootstrap";
import { DEBUG } from "../App";

// Display a form from the provided data fields.
export function formMaker(
  formSchema,
  isValid,
  formData,
  setFormData,
  formErrors,
  setFormErrors,
  tabIndexOffset = 1
) {
  const handleInputChange = (event) => {
    const key = event.target.name;
    const value = event.target.value;

    const state = { ...formData };
    state[key] = value;
    setFormData(state);

    const errors = { ...formErrors };
    errors[key] = !isValid(key, value, formData);
    setFormErrors(errors);
  };

  return (
    <>
      {formSchema.map((item, index) => {
        return (
          <Form.Group as={Row} controlId={item.name} key={index}>
            <Form.Label column sm="3">
              {item.label}
              {item.required && <span className="required"> *</span>}
            </Form.Label>
            <Col sm="9">
              <Form.Control
                name={item.name}
                as={item.as}
                type={item.type}
                onChange={handleInputChange}
                isInvalid={formErrors[item.name]}
                value={formData[item.name] || ""}
                tabIndex={`${index + tabIndexOffset}`}
              >
                {item.as &&
                  item.as === "select" &&
                  item.options &&
                  item.options.map((option, ind) => {
                    // Handle both string options and {value, label} objects
                    const optionValue =
                      typeof option === "object" ? option.value : option;
                    const optionLabel =
                      typeof option === "object" ? option.label : option;
                    return (
                      <option key={ind} value={optionValue}>
                        {optionLabel}
                      </option>
                    );
                  })}
              </Form.Control>
              <Form.Control.Feedback type="invalid">
                {item.feedback}
              </Form.Control.Feedback>
              <Form.Text
                id={`${item.name}-help`}
                muted
                dangerouslySetInnerHTML={{ __html: item.help || "<p></p>" }}
              />
            </Col>
          </Form.Group>
        );
      })}
    </>
  );
}

// Display a read-only tabular view of some data given its schema.
export function viewMaker(formSchema, formData) {
  return (
    <Table responsive striped bordered>
      <tbody>
        {formSchema.map((item, index) => {
          return (
            <tr key={index}>
              <th className="align-middle" scope="row" style={{ width: "25%" }}>
                {item.label}:
              </th>
              <td className="align-middle">
                {formData[item.name] === 0 ||
                formData[item.name] /* Don't show falsy values except for 0 */
                  ? item.view
                    ? item.view(formData[item.name])
                    : formData[item.name]
                  : ""}
              </td>
            </tr>
          );
        })}
      </tbody>
    </Table>
  );
}

export const compareSemesters = (input1, input2) => {
  let { term: term1, year: year1 } = input1;
  let { term: term2, year: year2 } = input2;

  const terms = ["Intersession", "Spring", "Summer", "Fall"]; // order is important
  term1 = terms.findIndex((term) => term === term1);
  term2 = terms.findIndex((term) => term === term2);

  year2 = Number.parseInt(year2.concat(term2));
  year1 = Number.parseInt(year1.concat(term1));

  return year2 - year1;
};

export const logger = (filename) => {
  return (message, data) => {
    DEBUG && console.log(`${filename} > ${message}`, data ? data : "");
  };
};

export function isAuthenticated(token, expiresAt) {
  if (!token || !expiresAt) {
    return false;
  }
  return new Date().getTime() / 1000 < expiresAt;
}
